// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3TSD5","load2":"Spinner_load2__2kgsH"};